import React from 'react';
import { TrendingUp, Award, Building2 } from 'lucide-react';
export function CredibilitySection() {
  const stats = [{
    icon: <Building2 className="w-8 h-8 text-emerald mb-4" data-id="element-50" />,
    value: '+50',
    label: 'Empresas Escaladas',
    description: 'Negocios de limpieza que han pasado de residencial a comercial.'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-emerald mb-4" data-id="element-51" />,
    value: '$2M+',
    label: 'En Contratos Cerrados',
    description: 'Generados anualmente por nuestros clientes usando el Sistema A.C.E.™'
  }, {
    icon: <Award className="w-8 h-8 text-emerald mb-4" data-id="element-52" />,
    value: '100%',
    label: 'Enfoque en Limpieza',
    description: 'No somos una agencia genérica. Solo trabajamos con dueños de cleaning businesses.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-carbon border-y border-carbon-lighter" data-id="element-53">
      <div className="max-w-6xl mx-auto" data-id="element-54">
        <div className="text-center mb-16" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-56">
            Resultados Reales para{' '}
            <span className="text-gold" data-id="element-57">Negocios Reales</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-58">
            La diferencia entre seguir compitiendo por precio y dominar tu
            mercado local está en tener el sistema correcto.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-59">
          {stats.map((stat, index) => <div key={index} className="bg-carbon-light border border-carbon-lighter p-8 rounded-lg text-center hover:border-gold/30 transition-colors" data-id="element-60">
              <div className="flex justify-center" data-id="element-61">{stat.icon}</div>
              <h3 className="text-4xl font-black text-white mb-2" data-id="element-62">
                {stat.value}
              </h3>
              <p className="text-gold font-bold text-lg mb-3" data-id="element-63">{stat.label}</p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-64">
                {stat.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}